import { isProductionEnv } from 'src/api';
import dayjs from 'src/modules/dayjs/dayjs-config';
import { CARD_GAME, CATCH_GAME, EVENT_CONFIG, EVENT_MODAL_DATES } from './eventConfig';
import {
  isEventDateListType,
  isEventEndDateType,
  isEventGameDateWithBonusType,
  isValidEventAction
} from './typeGuards';
import { EventDurationType, EventGamesType, GameStructureType } from './types';
import { getEventModalShownDatesFromLS } from 'src/modules/EventModal/utils';

export function getEventGameDateWithBonus(action: EventGamesType) {
  if (isValidEventAction(action)) {
    const actionsDuration = EVENT_CONFIG[action] as EventDurationType;
    if (isEventGameDateWithBonusType(actionsDuration)) {
      return actionsDuration;
    }
  }
}

function checkEventDate(action: string): boolean {
  if (isValidEventAction(action)) {
    const actionsDuration = EVENT_CONFIG[action] as EventDurationType;

    if (isEventEndDateType(actionsDuration)) {
      const { startDate: start, endDate: end } = actionsDuration;
      const currentDate = dayjs.utc();
      const startDate = dayjs.utc(start, 'YYYY-MM-DD');
      const endDate = dayjs.utc(end, 'YYYY-MM-DD').add(1, 'day');
      return currentDate >= startDate && currentDate < endDate;
    }

    if (isEventDateListType(actionsDuration)) {
      const { dateList } = actionsDuration;
      const currentDate = dayjs.utc().format('YYYY-MM-DD');
      return dateList.includes(currentDate);
    }

    if (isEventGameDateWithBonusType(actionsDuration)) {
      const { prodDatesWithBonuses } = actionsDuration;
      const currentDate = dayjs.utc().format('YYYY-MM-DD');
      return Object.hasOwn(prodDatesWithBonuses, currentDate);
    }
  }
  return false;
}

export const isShowEvent = (event: keyof typeof EVENT_CONFIG | (string & {})) => {
  return checkEventDate(event);
};
/**
 * @deprecated
 * @todo При появлении евента с модальным окном необходимо:
 * - внести EVENT_MODAL_DATES в EVENT_CONFIG.
 * - переиспользовать checkEventDate
 */
export const isShowEventModal = () => {
  const currentDateObject = EVENT_MODAL_DATES.find(
    (date) => dayjs(date).utc().isToday() && dayjs().utc().isAfter(date, 'second')
  );
  const fullDate = dayjs(currentDateObject).toString();

  const datesFromLs = getEventModalShownDatesFromLS();

  const shouldShowModal = Boolean(currentDateObject) && !datesFromLs.includes(fullDate);

  return {
    shouldShowModal,
    fullDate,
    day: dayjs(currentDateObject).utc().date()
  };
};

const createGameStructure = (action: EventGamesType): GameStructureType => {
  const actionsDuration = getEventGameDateWithBonus(action);
  if (actionsDuration) {
    const { devBonuses, prodDatesWithBonuses } = actionsDuration;
    const gameStructure: GameStructureType = { dev: { idBonusWin: devBonuses.id, attempts: [] } };
    for (const date in prodDatesWithBonuses) {
      gameStructure[date] = { idBonusWin: prodDatesWithBonuses[date].id, attempts: [] };
    }
    return gameStructure;
  }
  return {};
};

export const catchGameStructure = createGameStructure(CATCH_GAME);
export const cardGameStructure = createGameStructure(CARD_GAME);

export const getCurrentDateKey = () => {
  return isProductionEnv ? dayjs.utc().format('YYYY-MM-DD') : 'dev';
};

export const getSpecialPromoEventDates = () => {
  const promoDate: { [key: string]: EventGamesType } = {};
  const cardGameDuration = getEventGameDateWithBonus(CARD_GAME);
  const catchGameDuration = getEventGameDateWithBonus(CATCH_GAME);
  if (cardGameDuration) {
    Object.keys(cardGameDuration.prodDatesWithBonuses).forEach((data) => {
      promoDate[data] = CARD_GAME;
    });
  }
  if (catchGameDuration) {
    Object.keys(catchGameDuration.prodDatesWithBonuses).forEach((data) => {
      promoDate[data] = CATCH_GAME;
    });
  }
  return promoDate;
};
